import { Ass_03, Exp_08, Lia_01, Lia_02, Lia_13 } from "../../Chart.js";
import { NewEntry } from "../../entry/NewEntry.js";
import { Template } from "../../template/Template.js";
import { findVariableValue } from "../../template/findVariableValue.js";

export const INCOMING_EU_INVOICE: Template = {
  id: "cd4a3f18-ad12-49cc-b5b5-5fda885d9e95",
  name: "Sissetulev EU arve KM-ta",
  variables: [
    {
      name: "Title",
      type: "text"
    },
    {
      name: "Invoice date",
      type: "date"
    },
    {
      name: "Payment date",
      type: "date"
    },
    {
      name: "Expense amount",
      type: "amount_eur"
    },
    {
      name: "Reverse VAT",
      type: "amount_eur"
    }
  ],
  generate: (values) => {
    const expenseAmount = Math.round(parseFloat(findVariableValue("Expense amount", values)) * 100);
    const vatAmount = Math.round(parseFloat(findVariableValue("Reverse VAT", values)) * 100);

    const invoiceDate = findVariableValue("Invoice date", values);

    const entry: NewEntry = {
      title: findVariableValue("Title", values),
      items: [
        {
          title: "Arve summa",
          date: invoiceDate,
          amount: expenseAmount,
          eurAmount: expenseAmount,
          currency: "eur",
          debit: Exp_08,
          credit: Lia_01
        },
        {
          title: "Arve tasumine",
          date: findVariableValue("Payment date", values),
          amount: expenseAmount,
          eurAmount: expenseAmount,
          currency: "eur",
          debit: Lia_01,
          credit: Ass_03
        },
        {
          title: "Pöördkäibemaks",
          date: invoiceDate,
          amount: vatAmount,
          eurAmount: vatAmount,
          currency: "eur",
          debit: Lia_13,
          credit: Lia_02
        },
        {
          title: "Pöördkäibemaksu arvestus tagastatavaks",
          date: invoiceDate,
          amount: vatAmount,
          eurAmount: vatAmount,
          currency: "eur",
          debit: Lia_02,
          credit: Lia_13
        }
      ]
    };

    return { type: "success", entry };
  }
};
